import { type InferOutput, nonEmpty, object, pipe, string } from "valibot";

export const CouponCodeSchema = object({
  code: pipe(string(), nonEmpty("Coupon code is required")),
});
export type CouponCodeSchemaType = InferOutput<typeof CouponCodeSchema>;
